import { render, staticRenderFns } from "./HistoricsFiles.vue?vue&type=template&id=437f097d"
import script from "./HistoricsFiles.vue?vue&type=script&lang=js"
export * from "./HistoricsFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports